// @flow
import type {
  IsFqdnAvailable,
} from '../../core/fqdn';
import type {
  MiddlewareDriver,
} from '../drivers/middleware';

export const isFqdnAvailable = (
  middlewareDriver: MiddlewareDriver,
): IsFqdnAvailable => (
  fqdn,
) => {
  return middlewareDriver({
    method: 'v0.isFqdnAvailable',
    data: {
      fqdn,
    },
  });
};

export default isFqdnAvailable;
